import { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Helmet } from 'react-helmet-async'
import { motion, AnimatePresence, MotionConfig } from 'framer-motion'

import useAnimation from '../../utils/hooks/useAnimation'
import OptionsContext from '../../utils/OptionsContext'
import { Button, Footer, PageHeader, Trashbin } from '../../components'
import styles from './CookiePolicy.module.scss'
import Check from '../../components/Icons/Check'

const CookiePolicy = () => {
  const { t } = useTranslation()
  const [deleted, setDeleted] = useState(false)
  const { toggleThemeSound } = useContext(OptionsContext)
  const [animate, trigger] = useAnimation({ y: 2 })

  useEffect(() => {
    toggleThemeSound(false)
  }, [toggleThemeSound])

  // Write a function for deleting local storage here and set the deleted state to true for two seconds
  const deleteLocalStorage = () => {
    localStorage.clear()
    setDeleted(true)
  }

  return (
    <>
      <Helmet>
        <title>{t('common:meta:title:cookiepolicy')}</title>
        <meta
          name="description"
          content={t('common:meta:description:cookiepolicy')}
        />
      </Helmet>
      <div className={styles.cookiePolicy}>
        <PageHeader
          buttonText={t('common:mainmenu:startpage')}
          buttonHref="/"
          heading={t('common:cookiepolicy:heading')}
          reloadDocument
        />
        <main className={styles.wrapper}>
          <p className={styles.preamble}>{t('common:cookiepolicy:preamble')}</p>
          <div className={styles.articleWrapper}>
            <article>
              <p>{t('common:cookiepolicy:paragraph1')}</p>
              <p>{t('common:cookiepolicy:paragraph2')}</p>
              <p>
                <strong>{t('common:cookiepolicy:paragraph3')}</strong>{' '}
                {t('common:cookiepolicy:paragraph4')}
              </p>
              <p>{t('common:cookiepolicy:paragraph5')}</p>
              <p>{t('common:cookiepolicy:paragraph6')}</p>
              <ul>
                <li>
                  <p>
                    {t('common:cookiepolicy:li1')}{' '}
                    <strong>{t('common:cookiepolicy:on')}</strong>/
                    {t('common:cookiepolicy:off')}
                  </p>
                </li>
                <li>
                  <p>
                    {t('common:cookiepolicy:li2')} {t('common:cookiepolicy:on')}
                    /<strong>{t('common:cookiepolicy:off')}</strong>
                  </p>
                </li>
                <li>
                  <p>
                    {t('common:cookiepolicy:li3')} {t('common:cookiepolicy:on')}
                    /<strong>{t('common:cookiepolicy:off')}</strong>
                  </p>
                </li>
                <li>
                  <p>
                    {t('common:cookiepolicy:li4')}{' '}
                    <strong>{t('common:cookiepolicy:on')}</strong>/
                    {t('common:cookiepolicy:off')}
                  </p>
                </li>
                <li>
                  <p>
                    {t('common:cookiepolicy:li5')} {t('common:cookiepolicy:on')}
                    /<strong>{t('common:cookiepolicy:off')}</strong>
                  </p>
                </li>
              </ul>
              <h2>{t('common:cookiepolicy:subheading1')}</h2>
              <p>{t('common:cookiepolicy:paragraph7')}</p>
              <div className={styles.deleteBtnWrapper}>
                <AnimatePresence>
                  <MotionConfig transition={{ duration: 0.75 }}>
                    {deleted ? (
                      <motion.p
                        className={styles.deletedText}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                      >
                        {t('common:cookiepolicy:deleted')} <Check />
                      </motion.p>
                    ) : (
                      <motion.div>
                        <Button
                          variant="secondary"
                          onMouseEnter={trigger}
                          onClick={deleteLocalStorage}
                          initial={{ opacity: 1 }}
                          animate={{ opacity: 0 }}
                          exit={{ opacity: 1 }}
                        >
                          {t('common:cookiepolicy:deletelocalstorage')}
                          <motion.span animate={animate}>
                            <Trashbin />
                          </motion.span>
                        </Button>
                      </motion.div>
                    )}
                  </MotionConfig>
                </AnimatePresence>
              </div>
              <p>{t('common:cookiepolicy:paragraph8')}</p>
            </article>
          </div>
        </main>
        <Footer />
      </div>
    </>
  )
}

export default CookiePolicy
